import type {TPermission} from "@/store/types";

export const getUserPermission = (user?: {
  admin_access?: boolean;
  purchase_access?: boolean;
  write_access?: boolean;
  user_type?: string;
  is_company?: boolean;
}): TPermission => {
  if (user?.user_type === "admin") return user.is_company ? "REFLUENCED_COMPANY_ADMIN" : "REFLUENCED_INFLUENCER_ADMIN";
  if (user?.admin_access) return "ADMIN";
  if (user?.write_access) return "WRITE";
  if (user?.purchase_access) return "PURCHASE";
  return "READ";
};
